import { MODEL_TYPE_LABELS, ModelTypeType } from '../data-qa-constants';
import { modelTypeColor } from '../model-colors';

interface ModelCapsuleProps {
  modelType: ModelTypeType;
  label?: string;
  // Filled (solid) when the capsule represents the active selection; tinted
  // otherwise. Layout/size come from the `.model-capsule` class in DataQA.scss;
  // only the data-driven color is inline (the palette lives in model-colors.ts).
  active?: boolean;
}

export const ModelCapsule = ({
  modelType,
  label = MODEL_TYPE_LABELS[modelType],
  active = false
}: ModelCapsuleProps) => {
  const { fg, bg } = modelTypeColor(modelType);
  const style = active
    ? { color: 'white', background: fg, borderColor: fg }
    : { color: fg, background: bg, borderColor: fg };
  return (
    <span className='model-capsule' style={style}>
      {label}
    </span>
  );
};
